/** 
 * @param {string} textAreaId [Required] Unique id for the text area
 * @param {string} textAreaLabel
 * @param {string} textAreaPlaceholderText
 * @param {string} textAreaAriaLabel [Required] Aria label for the text area
 * @param {string} textAreaNumberOfRows [Optional] Number of rows within the text area
 * 
 * @param {string} textAreaContent
 * @param {function} handleChange 
*/
function TextArea(props){
    if(props.textAreaId === undefined){
        return null;
    }

    let numberOfRows = "3";
    if(props.textAreaNumberOfRows !== undefined){
        numberOfRows = props.textAreaNumberOfRows;
    }

    if(props.textAreaAriaLabel === undefined){
        return null;
    }

    return(
        <div className="Form__Element FormTextbox FormTextbox--Textarea mt-3">
            <label htmlFor={props.textAreaId} className="book-meeting__sublabel">
                {props.textAreaLabel}
            </label>
            <textarea 
                id={props.textAreaId} 
                rows={numberOfRows}
                className="FormTextbox__Input"
                value={props.textAreaContent}
                placeholder={props.textAreaPlaceholderText} 
                onChange={e => {
                    props.handleChange(e.target.value);
                }}
                aria-label={props.textAreaAriaLabel}
            >
                
            </textarea>
        </div>
    )
}

export default TextArea;